export type SessionRecordStatus = "scheduled" | "completed" | "cancelled" | "no_show";
export type SessionDisplayStatus = SessionRecordStatus | "pending_outcome";

export function getSessionDisplayStatus(
  session: { status: string; scheduledAt?: string | null },
  nowMs = Date.now(),
): string {
  if (
    session.status === "scheduled" &&
    session.scheduledAt &&
    Date.parse(session.scheduledAt) <= nowMs
  ) {
    return "pending_outcome";
  }

  return session.status;
}
